export default function CsharpStringMethods() {
  return (
    <h2>Csharp String Methods</h2>
  );
}
